import React from 'react';
import { Stack, Heading, Text, Flex, Switch, useDisclosure } from '@televet/kibble-ui';
import useClinicUser from 'shared/hooks/useClinicUser';
import EnableRemindersModal from './EnableRemindersModal';
import { useServiceReminders } from './useServiceReminders';

export const RemindersGlobalToggle = (): JSX.Element => {
  const { currentClinicId } = useClinicUser();

  const { clinicHasServiceReminders } = useServiceReminders(currentClinicId);

  const {
    isOpen: isConfirmationModalOpen,
    onOpen: openConfirmationModal,
    onClose: closeConfirmationModal,
  } = useDisclosure();

  return (
    <>
      <Stack my={5} spacing={1}>
        <Flex align="center">
          <Heading minW="fit-content" size="xs" mr={2}>
            Enable Reminders
          </Heading>
          <Switch
            alignSelf="flex-end"
            justifySelf="flex-end"
            isChecked={clinicHasServiceReminders}
            onChange={openConfirmationModal}
          />
        </Flex>
        <Text maxWidth="500px" size="sm" variant="subtle">
          When switched on, active and scheduled service reminders will send normally. When switched off, all service
          reminders will stop sending regardless of status.
        </Text>
      </Stack>
      <EnableRemindersModal isOpen={isConfirmationModalOpen} onClose={closeConfirmationModal} />
    </>
  );
};
